var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta-help"},[_c('h3',{staticClass:"cta-help__h"},[_vm._v(_vm._s(_vm.$t("faq.noResponseFound")))]),_vm._v(" "),_c('div',{staticClass:"cta-help__actions",domProps:{"innerHTML":_vm._s(_vm.$t('faq.noResponseFoundCta'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }